package com.hyperether.goodjob.map

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.State
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.viewinterop.WebElementView
import com.hyperether.goodjob.repository.remote.model.LatLng
import com.hyperether.goodjob.setupZoomDetection
import kotlinx.browser.document
import kotlinx.coroutines.delay
import org.w3c.dom.HTMLDivElement
import web.navigator.navigator

@OptIn(ExperimentalComposeUiApi::class)
@Composable
actual fun MapComponent(
    showMapWeb: State<Boolean>,
    showMap: Boolean,
    markers: List<Marker>,
    currentPosition: State<LatLng?>,
    mapZoom: State<Boolean?>,
    onMapPanned: (Double, Double) -> Unit
) {

    LaunchedEffect(Unit) {
        onMapPan = { lat, lon ->
            onMapPanned(lat, lon)
            println("Map was panned to: $lat, $lon")
        }
    }

    LaunchedEffect(mapZoom.value) {
        mapZoom.value?.let {
            setZoom(15)
        }
    }

    val lastMarker = if (markers.isNotEmpty()) markers[markers.size - 1] else ""
    console.log("MapComponent called with ${markers.size} markers, last: $lastMarker pos:${currentPosition.value} showMap=$showMap, showMapWeb=${showMapWeb.value}")

    if (showMap && showMapWeb.value) {
        Box(modifier = Modifier.fillMaxSize()) {
            WebElementView(
                factory = {
                    // Always create a fresh map div
                    val div = document.createElement("div") as HTMLDivElement
                    div.apply {
                        id = "mapid" // Unique ID
                        style.width = "100%"
                        style.height = "100%"
                        style.asDynamic().pointerEvents = "auto"
                    }

                    // Initialize Google Maps on this div
                    initMapOnDiv(div)

                    div
                },
                modifier = Modifier.fillMaxSize(),
                update = { div ->
                    console.log("MapComponent update called with ${markers.size} markers")
                }
            )
        }

        // Update markers and camera when they change
        LaunchedEffect(
            markers.size,
            markers.joinToString { "${it.lat},${it.lng},${it.title}" },
            currentPosition.value,
            Unit
        ) {
            console.log("LaunchedEffect triggered - markers: ${markers.size}, currentPosition: ${currentPosition.value}")

            // Give a small delay to ensure map is initialized
            kotlinx.coroutines.delay(100)

            clearAllMarkers()
            markers.forEach { marker ->
                console.log("Adding marker in LaunchedEffect: lat=${marker.lat}, lng=${marker.lng}, title=${marker.title}, status=${marker.status}")
                addMarker(marker.lat, marker.lng, marker.title, marker.status)
            }

            // Debug current position value
            console.log("currentPosition.value: ${currentPosition.value}")

            val cameraLatLng = when {
                currentPosition.value != null -> {
                    console.log("Using currentPosition for camera")
                    currentPosition.value!!
                }

                markers.isNotEmpty() -> {
                    console.log("Using marker position for camera")
                    LatLng(markers[0].lat, markers[0].lng)
                }

                else -> {
                    console.log("Using default position for camera")
                    LatLng(46.948165, 7.440583) // Default to Bern
                }
            }
            console.log("Setting camera in LaunchedEffect to: ${cameraLatLng.latitude}, ${cameraLatLng.longitude}")
            setCamera(lat = cameraLatLng.latitude, lng = cameraLatLng.longitude)
        }

        // Zoom detection is handled globally in main.kt
        // Don't call setupZoomDetection() here to avoid duplicate listeners
    }


    DisposableEffect(Unit) {
        onDispose {

        }
    }
}


@JsName("addMarker")
external fun addMarker(lat: Double, lng: Double, title: String, status: String)

@JsName("setCamera")
external fun setCamera(lat: Double, lng: Double)

@JsName("setZoom")
external fun setZoom(zoom: Int)

@JsName("clearAllMarkers")
external fun clearAllMarkers()

@JsName("onMapPan")
external var onMapPan: ((Double, Double) -> Unit)?

@JsName("initMapOnDiv")
external fun initMapOnDiv(div: HTMLDivElement)

@JsName("cleanupMap")
external fun cleanupMap()